import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { fetchAdminTaskListTasks } from '../../../../features/adminSlice'
import { TaskConfigDetails } from './TaskConfigDetails'
import styles from '../AdminConfigsPage.module.scss'

export function TaskListTasksPage() {
	const { taskListKey } = useParams()
	const dispatch = useDispatch()
	const taskListTasks = useSelector((s) => s.admin.taskListTasks)
	const loading = useSelector((s) => s.admin.taskListTasksLoading)
	const error = useSelector((s) => s.admin.taskListTasksError)

	useEffect(() => {
		if (taskListKey) {
			dispatch(fetchAdminTaskListTasks(taskListKey))
		}
	}, [dispatch, taskListKey])

	const weddingTypeLabels = taskListTasks?.weddingTypes?.join(', ')

	return (
		<div className={styles.panelCard} data-cy="admin-task-list-tasks">
			<Link
				to="/admin/configs/wedding-tasks"
				className={styles.backLink}
				data-cy="admin-back-to-wedding-types"
			>
				← Back to wedding types
			</Link>
			<Typography component="h2" className={styles.panelTitle}>
				Task list: <code>{taskListKey}</code>
			</Typography>
			{weddingTypeLabels && (
				<p className={styles.panelBody}>
					<strong>Wedding types:</strong> {weddingTypeLabels}
				</p>
			)}
			{loading && <p className={styles.panelBody}>Loading…</p>}
			{error && <p className={styles.errorText}>{error}</p>}
			{!loading && !error && taskListTasks?.tasks?.length === 0 && (
				<p className={styles.panelBody}>No tasks in this list.</p>
			)}
			{taskListTasks?.tasks?.map((task) => (
				<Accordion
					key={task.taskId}
					className={styles.taskAccordion}
					data-cy={`admin-task-accordion-${task.taskId}`}
				>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography className={styles.accordionSummary}>
							{task.task || task.taskId}
							{task.hasPatch && (
								<span className={styles.patchBadge}>
									Customized
								</span>
							)}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<TaskConfigDetails task={task} showPatch />
					</AccordionDetails>
				</Accordion>
			))}
		</div>
	)
}
